var map = {
	"./subdir/tmpl": 12,
	"./subdir/tmpl.js": 12,
	"./templateLoader": 9,
	"./templateLoader.js": 9,
	"./templateLoaderIndirect": 8,
	"./templateLoaderIndirect.js": 8,
	"./tmpl": 10,
	"./tmpl.js": 10,
	"xyz": 13,
	"xyz.js": 13
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.id = 2;
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;



/*****************
 ** WEBPACK FOOTER
 ** ./parsing/context/templates .
 ** module id = 2
 ** module chunks = 0
 **/